<template>

  <div>
    <!-- AppBar de finalizar venta -->
    <v-toolbar
        dark
        color="primary"
    >
      <v-btn
          icon
          dark
          @click="$emit('not_is_finalizar_venta')"
      >
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>{{ $t("Total") }}: {{ total | money }}</v-toolbar-title>
      <v-spacer></v-spacer>

      <!-- GUARDAR -->
      <v-btn
          class="white primary--text mr-3"
          @click="save_venta"
          :disabled="(this.cliente_venta.is_anonymous && this.deuda > 0) || disable_tbai"
      >
        <v-icon>mdi-cash</v-icon>
        {{ $t("Cobrar") }}
      </v-btn>
      <v-toolbar-items>
        <v-menu offset-y bottom right v-if="!((this.cliente_venta.is_anonymous && this.deuda > 0) || disable_tbai)">
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" text v-on="on" >
              {{ $t("Otros") }}
              <v-icon>mdi-chevron-down</v-icon>
            </v-btn>
          </template>

          <v-list dense>

            <v-list-item @click="save_and_print">
              <v-list-item-action>
                <v-list-item-title>{{ $t("Cobrar e imprimir factura") }}</v-list-item-title>
              </v-list-item-action>
            </v-list-item>

            <v-list-item @click="save_and_ticket()">
              <v-list-item-action>
                <v-list-item-title>{{ $t("Cobrar e imprimir ticket") }}</v-list-item-title>
              </v-list-item-action>
            </v-list-item>
            <v-list-item :disabled="cliente_venta.is_anonymous || !cliente_venta.email" @click="save_and_email">
              <v-list-item-action>
                <v-list-item-title>{{ $t("Cobrar y enviar factura por email") }}</v-list-item-title>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-toolbar-items>

    </v-toolbar>
    <!--Fin AppBar -->

    <!-- FINALIZAR VENTA -->
    <v-row class="mt-0">
      <v-col v-show="total_productos_escandallo > 0 && show_escandallo" md="12" lg="4">
        <v-card :height="$vuetify.breakpoint.lgAndUp ? '90vh' : ''" class="pa-3 mx-3" elevation="5">
          <v-card-title class="titulo_card">{{ $t("Escandallo") }}</v-card-title>
          <v-card-text>
            <TablaProductos
                :selected_filters="{ is_active: true, servicios_escandallo__in:servicios_venta.join(',') }"
                :is_venta="true"
                :is_escandallo="true"
                @on_total="on_total_productos_escandallo"
                @modificar_stock="modificar_stock"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="12" :lg="total_productos_escandallo > 0 && show_escandallo?4:6">
        <v-card :height="$vuetify.breakpoint.lgAndUp ? '90vh' : ''" class="pa-3 mx-3" elevation="5">
          <v-card-title class="titulo_card">{{ $t("Pago") }}</v-card-title>
          <v-card-text>
            <v-row v-if="venta.forma_pago !== CONSTANTS.FORMAS_PAGO.TARJETA_FIDELIDAD &&
             venta.forma_pago !== CONSTANTS.FORMAS_PAGO.TARJETA_REGALO">
              <v-col v-if="$vuetify.breakpoint.lgAndUp">
                <h3>{{ $t("Total a pagar") }}: <span class="big">{{ venta.total | money }}</span></h3>
                <ValidationObserver ref="validationObserverEntrega">
                  <v-form ref="formEntrega" lazy-validation class="pa-1">
                    <v-row v-if="venta.forma_pago === CONSTANTS.FORMAS_PAGO.MIXTO">
                      <v-col cols="6">
                        <ValidationProvider rules="required"
                                            :name="$t('Efectivo').toLowerCase()"
                                            v-slot="{ errors, classes }"
                        >
                          <div class="control" :class="classes">
                            <v-text-field
                                class="mt-5"
                                v-model="venta.entrega_efectivo"
                                type="number"
                                hide-details
                                :label="$t('Efectivo')"
                                outlined
                                dense
                                autofocus
                                @keydown.enter.prevent
                            >
                              <template v-slot:append>
                                <span class="pt-1">{{ $store.state.centro.centro.divisa_obj.simbolo }}</span>
                              </template>
                            </v-text-field>
                          </div>
                          <span class="error--text">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </v-col>

                      <v-col cols="6">
                        <ValidationProvider rules="required"
                                            :name="$t('Tarjeta').toLowerCase()"
                                            v-slot="{ errors, classes }"
                        >
                          <div class="control" :class="classes">
                            <v-text-field
                                class="mt-5"
                                v-model="venta.entrega_tarjeta"
                                type="number"
                                hide-details
                                :label="$t('Tarjeta')"
                                outlined
                                dense
                                autofocus
                                @keydown.enter.prevent
                            >
                              <template v-slot:append>
                                <span class="pt-1">{{ $store.state.centro.centro.divisa_obj.simbolo }}</span>
                              </template>
                            </v-text-field>
                          </div>
                          <span class="error--text">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                    <v-row v-else>
                      <v-col cols="12">
                        <ValidationProvider rules="required"
                                            :name="$t('Cliente entrega').toLowerCase()"
                                            v-slot="{ errors, classes }"
                        >
                          <div class="control" :class="classes">
                            <v-text-field
                                class="mt-5"
                                v-model="venta.entrega"
                                type="number"
                                hide-details
                                :label="$t('Cliente entrega')"
                                outlined
                                dense
                                autofocus
                                @keydown.enter.prevent
                            >
                              <template v-slot:append>
                                <span class="pt-1">{{ $store.state.centro.centro.divisa_obj.simbolo }}</span>
                              </template>
                            </v-text-field>
                          </div>
                          <span class="error--text">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </v-col>
                    </v-row>
                  </v-form>
                </ValidationObserver>
              </v-col>
              <v-col v-else>
                <v-row>
                    <v-col cols="4" class="d-flex align-center justify-center">
                    <h3>
                      {{ $t("Total a pagar") }}: {{ venta.total | money }}
                    </h3>
                    </v-col>
                    <v-col cols="8">
                      <div>
                        <ValidationObserver ref="validationObserverEntrega">
                          <v-form ref="formEntrega" lazy-validation class="pa-1">
                            <div v-if="venta.forma_pago === CONSTANTS.FORMAS_PAGO.MIXTO">
                              <v-row>
                              <v-col cols="6">
                                <ValidationProvider rules="required"
                                                    :name="$t('Efectivo').toLowerCase()"
                                                    v-slot="{ errors, classes }"
                                >
                                  <div class="control" :class="classes">
                                    <v-text-field
                                        class="mt-5"
                                        v-model="venta.entrega_efectivo"
                                        type="number"
                                        hide-details
                                        :label="$t('Efectivo')"
                                        outlined
                                        dense
                                        autofocus
                                        @keydown.enter.prevent
                                    >
                                      <template v-slot:append>
                                        <span class="pt-1">{{ $store.state.centro.centro.divisa_obj.simbolo }}</span>
                                      </template>
                                    </v-text-field>
                                  </div>
                                  <span class="error--text">{{ errors[0] }}</span>
                                </ValidationProvider>
                              </v-col>

                              <v-col cols="6">
                                <ValidationProvider rules="required"
                                                    :name="$t('Tarjeta').toLowerCase()"
                                                    v-slot="{ errors, classes }"
                                >
                                  <div class="control" :class="classes">
                                    <v-text-field
                                        class="mt-5"
                                        v-model="venta.entrega_tarjeta"
                                        type="number"
                                        hide-details
                                        :label="$t('Tarjeta')"
                                        outlined
                                        dense
                                        autofocus
                                        @keydown.enter.prevent
                                    >
                                      <template v-slot:append>
                                        <span class="pt-1">{{ $store.state.centro.centro.divisa_obj.simbolo }}</span>
                                      </template>
                                    </v-text-field>
                                  </div>
                                  <span class="error--text">{{ errors[0] }}</span>
                                </ValidationProvider>
                              </v-col>
                              </v-row>
                            </div>
                            <div v-else>
                                <ValidationProvider rules="required"
                                                    :name="$t('Cliente entrega').toLowerCase()"
                                                    v-slot="{ errors, classes }"
                                >
                                  <div class="control" :class="classes">
                                    <v-text-field
                                        v-model="venta.entrega"
                                        type="number"
                                        hide-details
                                        :label="$t('Cliente entrega')"
                                        outlined
                                        dense
                                        autofocus
                                        @keydown.enter.prevent
                                    >
                                      <template v-slot:append>
                                        <span class="pt-1">{{ $store.state.centro.centro.divisa_obj.simbolo }}</span>
                                      </template>
                                    </v-text-field>
                                  </div>
                                  <span class="error--text">{{ errors[0] }}</span>
                                </ValidationProvider>
                            </div>
                          </v-form>
                        </ValidationObserver>
                      </div>
                    </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <hr>
              </v-col>
            </v-row>

            <v-row v-if="venta.forma_pago !== CONSTANTS.FORMAS_PAGO.TARJETA_FIDELIDAD &&
             venta.forma_pago !== CONSTANTS.FORMAS_PAGO.TARJETA_REGALO">
              <v-col>
                <h3 class="text-center">{{ $t("A devolver") }}: <span class="big">{{ devolver | money }}</span></h3>
              </v-col>
              <v-col>
                <h3 class="text-center">{{ $t("Deuda") }}: <span
                    :class="{big: true, 'red--text': deuda > 0}">{{ deuda | money }}</span></h3>
                <h3 class="text-center red--text" v-if="this.cliente_venta.is_anonymous && this.deuda > 0">
                  {{ $t('Un cliente anónimo no puede generar deudas') }}
                </h3>
              </v-col>
            </v-row>

            <v-row v-if="venta.forma_pago === CONSTANTS.FORMAS_PAGO.TARJETA_FIDELIDAD ||
             venta.forma_pago === CONSTANTS.FORMAS_PAGO.TARJETA_REGALO">
              <v-col>
                <h3 class="text-center" v-if="venta.forma_pago === CONSTANTS.FORMAS_PAGO.TARJETA_REGALO">
                  {{ $t("Importe a usar de la") + ' ' + $t('Tarjeta Regalo').toLowerCase() }}: <span class="big">
                  {{ venta.importe_tarjeta_regalo | money }}</span>
                </h3>

                <h3 class="text-center" v-if="venta.forma_pago === CONSTANTS.FORMAS_PAGO.TARJETA_FIDELIDAD">
                  {{ $t("Importe a usar de la") + ' ' + $t('Tarjeta Fidelidad').toLowerCase() }}: <span class="big">
                  {{ venta.importe_tarjeta_fidelidad | money }}</span>
                </h3>
              </v-col>
            </v-row>

            <v-row v-if="!cliente_venta.is_anonymous && centro.is_enviar_encuesta">
              <v-col>
                <v-switch
                    v-model="venta.is_enviar_encuesta"
                    :label="'¿' + $t('Enviar encuesta') + '?'"
                ></v-switch>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-if="centro.is_tips" md="12" :lg="total_productos_escandallo > 0 && show_escandallo?4:6">
        <v-card :height="$vuetify.breakpoint.lgAndUp ? '90vh' : ''" class="pa-3 mx-3" elevation="5">
          <v-card-title class="titulo_card">{{ $t("Propinas") }}</v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-btn
                    class="ma-2 white--text"
                    small
                    color="green"
                    @click="add_tip"
                >{{ $t("Añadir propina") }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <div class="contTips">
                  <ValidationObserver ref="validationObserverTips">
                    <v-form ref="formTips" lazy-validation class="pa-1" style="height: 70vh; overflow-y: scroll; overflow-x: hidden">
                      <v-row
                          v-for="(current_tip, index) in venta.tips"
                          :key="index">
                        <v-col cols="3">
                          <ValidationProvider rules="required"
                                              :name="$t('Importe').toLowerCase()"
                                              v-slot="{ errors, classes }"
                          >
                            <div class="control" :class="classes">
                              <v-text-field
                                  v-model="current_tip.importe"
                                  type="number"
                                  hide-details
                                  :label="$t('Importe')"
                                  outlined
                                  dense
                                  @keydown.enter.prevent
                              />
                            </div>
                            <span class="error--text">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="4">
                          <ValidationProvider rules="required"
                                              :name="$t('Empleado').toLowerCase()"
                                              v-slot="{ errors, classes }"
                          >
                            <div class="control" :class="classes">
                              <v-select
                                  v-model="current_tip.user"
                                  hide-details
                                  :label="$t('Empleado')"
                                  :items="data_form.empleados"
                                  :no-data-text="$t('No hay datos')"
                                  dense
                                  outlined
                                  @keydown.enter.prevent
                              />
                            </div>
                            <span class="error--text">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </v-col>

                        <v-col cols="3">
                          <ValidationProvider rules="required"
                                              :name="$t('Forma pago').toLowerCase()"
                                              v-slot="{ errors, classes }"
                          >
                            <div class="control" :class="classes">
                              <v-select
                                  v-model="current_tip.forma_pago"
                                  hide-details
                                  :label="$t('Forma pago')"
                                  :items="data_form.formas_pago"
                                  :no-data-text="$t('No hay datos')"
                                  dense
                                  outlined
                                  @keydown.enter.prevent
                              />
                            </div>
                            <span class="error--text">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </v-col>

                        <v-col class="pt-4" cols="1" md="2" sm="5">
                          <v-btn
                              icon
                              class="red"
                              dark
                              @click="delete_tip(index)"
                          >
                            <v-icon>mdi-delete-forever</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-form>
                  </ValidationObserver>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
  <!-- FIN FINALIZAR VENTA -->
</template>

<script>
import CONSTANTS from "@/utils/constants";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import Swal from "sweetalert2";

export default {
  name: "FinalizarVenta",
  data() {
    return {
      CONSTANTS,
      venta: {
        lineas_venta: [],
      },
      servicios_venta: [],
      total_productos_escandallo: 0,
      show_escandallo: true,
      movimientos_stock: [],
      configuracion_venta: null,
      disable_tbai: true,
    }
  },
  props: [
    'venta_original',
    'total',
    'cliente_venta',
    'centro',
    'data_form',
    'validationObserver',
    'consumidos_previos',
    'consumidos_nuevos'
  ],
  async mounted() {
    this.venta = {...this.$props.venta_original}
    this.venta.tips = [...this.$props.venta_original.tips]
    await this.get_servicios_venta()
    await this.get_configuracion_venta()

    if (this.$store.state.centro.centro.is_ticketbai_activo) {
      let has_producto = false
      let has_otro = false
      let impuesto = null
      let is_diferent_impuesto = false
      this.venta.lineas_venta.forEach(linea => {
        if (linea.producto) {
          has_producto = true
        } else {
          has_otro = true
        }
        if (impuesto === null) {
          impuesto = linea.impuesto
        } else if (linea.impuesto !== impuesto) {
          is_diferent_impuesto = true
        }
      })

      if (is_diferent_impuesto && (this.venta.valor_descuento > 0 ||
          this.venta.puntos_utilizados > 0 || this.venta.importe_tarjeta_fidelidad ||
          this.venta.importe_tarjeta_regalo)) {
        this.$snotify.error(
            this.$t("Solo se puede aplicar descuentos generales a una venta con conceptos con el mismo impuesto"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
        return
      }

      if (has_producto && has_otro) {
        const data = await this.$store.dispatch('ticketbai/load_empresa')
        if ((data['tax_of_significance_code'] === '01' || data['productos_tax_of_significance_code'] === '01') &&
            data['productos_tax_of_significance_code'] &&
            data['tax_of_significance_code'] !== data['productos_tax_of_significance_code']) {
          this.$snotify.error(this.$t('Por favor, revisa la configuración de régimenes fiscales y crea una venta separada para los productos.'))
          this.$snotify.error(
              this.$t("El régimen fiscal 'Regimen General' no es compatible con los régimenes 'Régimen Recargo Equivalencia' y 'Régimen Simplificado'."),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
          return
        }
      }
    }
    this.disable_tbai = false
  },

  computed: {
    devolver() {
      let devolver
      if (this.venta.forma_pago === CONSTANTS.FORMAS_PAGO.MIXTO){
        devolver = parseFloat((parseFloat(this.venta.entrega_efectivo) + parseFloat(this.venta.entrega_tarjeta) - this.venta.total).toFixed(2))
      } else {
        devolver = parseFloat(parseFloat(this.venta.entrega) - parseFloat(this.venta.total).toFixed(2))
      }

      return devolver > 0 ? devolver : 0
    },

    deuda() {
      let deuda
      if (this.venta.forma_pago === CONSTANTS.FORMAS_PAGO.MIXTO){
        deuda = parseFloat((this.venta.total - parseFloat(this.venta.entrega_efectivo) - parseFloat(this.venta.entrega_tarjeta)).toFixed(2))
      } else {
        deuda = parseFloat((this.venta.total - this.venta.entrega).toFixed(2))
      }

      return (this.venta.entrega >= 0 && deuda > 0) ? deuda : 0
    },
    jwt(){
      return this.$store.state.auth.access_token
    },
    centro(){
      return this.$store.state.centro.centro
    }
  },
  methods: {

    on_total_productos_escandallo(total_productos) {
      this.total_productos_escandallo = total_productos
    },

    modificar_stock(producto){
      let updated = false

      this.movimientos_stock.forEach((item, index)=>{
        if (item.id === producto.id) {
          this.movimientos_stock[index] = producto
          updated = true
        }
      })

      if (!updated) {
        this.movimientos_stock.push(producto)
      }
    },

    /**
     * Obtenermos la configuración de venta del centro
     * @returns {Promise<void>}
     */
    async get_configuracion_venta() {
      try {
        this.configuracion_venta = await this.$store.dispatch('configuraciones/get', 'venta')
      } catch (err) {
        this.$snotify.error(
            this.$t("Ha ocurrido un error"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    get_servicios_venta() {
      this.servicios_venta = []
      this.venta.lineas_venta.forEach((current_linea) => {
        if (current_linea.servicio) {
          this.servicios_venta.push(current_linea.servicio)
        }
      })

      // Escondemos el escandallo en caso de que no haya servicios
      if (this.servicios_venta.length === 0) {
        this.show_escandallo = false
      }
    },


    /**
     * Añade una nueva propina
     */
    add_tip() {
      if (!this.venta.tips) {
        this.venta['tips'] = []
      }
      this.venta.tips.push({
        importe: 0,
        forma_pago: 1,
        user: this.venta.assigned_to
      })
    },

    /**
     * Elimina una propina
     * @param index
     */
    delete_tip(index) {
      this.venta.tips.splice(index, 1);
    },


    /**
     * Finaliza la venta
     * @returns {Promise<void>}
     */
    async save_venta() {
      switch (this.configuracion_venta.imprimir_tickets) {
        case 0:
          await this.save_and_close()
          break
        case 1:
          await this.save_and_ticket()
          break
        case 2:
          const confirm = await this.$fire({
            html: this.$t('¿Desea imprimir el ticket?'),
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonText: this.$t('Imprimir'),
            cancelButtonText: this.$t('No Imprimir'),
          })
          if(confirm.value === true){
            await this.save_and_ticket()
          } else if(confirm.dismiss === Swal.DismissReason.cancel) {
            await this.save_and_close()
          }
          return
      }
    },

    /**
     * Guarda la venta y cierra la ventana
     * @returns {Promise<void>}
     */
    async save_and_close() {
      const venta = await this.save()
      this.$emit('on_save', venta)
    },

    /**
     * Guarda la venta e imprime la factura de la misma
     * @returns {Promise<void>}
     */
    async save_and_print() {
      const venta = await this.save()
      await this.$store.dispatch('venta/imprimir_factura', {id: venta.id, ticket: venta.num_ticket})
      this.$emit('on_save', venta)
    },

    /**
     * Guarda la venta e imprime el ticket
     * @returns {Promise<void>}
     */
    async save_and_ticket() {
      const venta = await this.save()

      // Impresora fiscal Italia
      if(this.centro.country === CONSTANTS.COUNTRY.ITALY && this.centro.is_epson_fiscal_printer){
        const url = `${process.env.VUE_APP_API_BASE_URL}ventas/ventas/${venta.id}/print-ticket-epson-fiscal/?x-token=${this.jwt}`
        window.open(url, '_blank');
      }else{
        let route_imprimir
        if (this.configuracion_venta.tipo_ticket === CONSTANTS.CONFIGURACION_TICKET.TICKET_ESTANDAR) {
          route_imprimir = this.$router.resolve({name: 'print_ticket', params: {id: venta.id}})
        } else {
          route_imprimir = this.$router.resolve({name: 'print_factura_simplificada', params: {id: venta.id}})
        }
        if (route_imprimir) {
          window.open(route_imprimir.href, '_blank');
        }
        this.$emit('on_save', venta)
      }
    },

    /**
     * Guarda la venta y envia la factura por correo electrónico
     * @returns {Promise<void>}
     */
    async save_and_email() {
      const venta = await this.save()
      await this.$store.dispatch('venta/enviar_email_factura', venta.id)
      this.$emit('on_save', venta)
    },

    /**
     * Guarda la venta y la devuelve
     * @returns {Promise<Object>}
     */
    async save() {
      switch (this.venta.forma_pago) {
        case 1: // Efectivo
          this.venta.entrega_efectivo = this.venta.entrega
          this.venta.entrega_tarjeta = 0
          break;

        case 2: // Tarjeta
          this.venta.entrega_tarjeta = this.venta.entrega
          this.venta.entrega_efectivo = 0
          break;

        case CONSTANTS.FORMAS_PAGO.MIXTO: // Mixto
          this.venta.entrega = Number(this.venta.entrega_efectivo) + Number(this.venta.entrega_tarjeta)
          this.venta.entrega = this.venta.entrega.toFixed(2)
          break;

        default:
          break;
      }

      if (this.venta.valor_descuento === '' || this.venta.valor_descuento === null) {
        this.venta.valor_descuento = 0
      }

      const form_valid = await this.$props.validationObserver.validate()
      let form_valid_entrega = true
      if (this.venta.forma_pago !== CONSTANTS.FORMAS_PAGO.TARJETA_REGALO && this.venta.forma_pago !== CONSTANTS.FORMAS_PAGO.TARJETA_FIDELIDAD) {
        form_valid_entrega = await this.$refs.validationObserverEntrega.validate()
      }

      let form_valid_tips
      this.centro.is_tips ? form_valid_tips = await this.$refs.validationObserverTips.validate() : form_valid_tips = true

      if (form_valid && form_valid_entrega && form_valid_tips) {
        const origin_fecha = this.venta.fecha

        try {
          this.venta.fecha = `${origin_fecha} ${this.$moment().format('HH:mm')}`
          const venta = await this.$store.dispatch("venta/save", {'venta': this.venta, 'token': this.$store.getters['auth/autologin_token']});

          const suma_bonos = this.consumidos_previos + this.consumidos_nuevos
          if(suma_bonos > 0){
            this.$snotify.info(
                this.$t("Se ha consumido la última sesión de {0} bono/s", [suma_bonos]),
                this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
            )
          }

          await this.$store.dispatch("producto/save_multiples", this.movimientos_stock);

          this.$snotify.success(
              this.$t("Acción realizada con éxito"),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
          return venta

        } catch (err) {
          this.$snotify.error(
              this.$t("Ha ocurrido un error"),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
        }
        this.venta.fecha = origin_fecha
      }
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    TablaProductos: () => import('@/views/Configuracion/Productos/Productos/components/TablaProductos'),
  },
}
</script>

<style scoped>
header {
  border-radius: 0 !important;
}

.big {
  font-size: 2em
}

.v-card__text, .v-card__actions {
  padding: 0 8px;
}
</style>
